import React, { createContext, useState } from "react";
import { formatDate } from "../../../../utils/formatDate";
import getDayOfCurrentMonth from "../../../../utils/getDayOfCurrentMonth";

const FaturamentoContratoContext = createContext();
const FaturamentoContratoContextProvider = ({ children }) => {
  const [client, setClient] = useState(null);
  const [initialDate, setInitialDate] = useState(
    formatDate({
      date: getDayOfCurrentMonth("first"),
      separator: "-",
      format: "yyyy-mm-dd",
    })
  );
  const [finalDate, setFinalDate] = useState(
    formatDate({
      date: getDayOfCurrentMonth("last"),
      separator: "-",
      format: "yyyy-mm-dd",
    })
  );
  const [filterBy, setFilterBy] = useState({
    label: "Vencimento",
    value: "dueDate",
  });
  const [typeContract, setTypeContract] = useState({
    label: "Todos",
    value: "all",
  });
  const [billingStatus, setBillingStatus] = useState({
    label: "Todos",
    value: "all",
  });
  const [filterDefaulters, setFilterDefaulters] = useState(true);
  const [inDays, setInDays] = useState("30");
  const [contracts, setContracts] = useState("0,00");
  const [reimbursableExpenses, setReimbursableExpenses] = useState("0,00");
  const [totalLooseItem, setTotalLooseItem] = useState("0,00");
  const [totalBilling, setTotalBilling] = useState("0,00");
  const [negativeTaxCnab, setNegativeTaxCnab] = useState(true);
  const [totalTaxCnab, setTotalTaxCnab] = useState("0,00");
  const [negativeTaxPix, setNegativeTaxPix] = useState(true);
  const [totalTaxPix, setTotalTaxPix] = useState("0,00");
  const [netTotal, setNetTotal] = useState("0,00");
  const [itensTable, setItensTable] = useState([]);
  const [mainLoading, setMainLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState([]);
  const [totalQyonBank, setTotalQyonBank] = useState("0,00");
  const [taxCnab, setTaxCnab] = useState("0,00");
  const [taxPix, setTaxPix] = useState("0,00");
  const [pagePropDefault, setPagePropDefault] = useState(0);
  const [negativeQB, setNegativeQB] = useState(false);
  const [disabledButtonSearch, setDisabledButtonSearch] = useState(false);
  const [loadingBtnSearch, setLoadingBtnSearch] = useState(false);
  const [expiredTotal, setExpiredTotal] = useState("0");
  const [expiringTotal, setExpiringTotal] = useState("0");

  return (
    <FaturamentoContratoContext.Provider
      value={{
        client,
        setClient,
        initialDate,
        setInitialDate,
        finalDate,
        setFinalDate,
        filterBy,
        setFilterBy,
        typeContract,
        setTypeContract,
        billingStatus,
        setBillingStatus,
        filterDefaulters,
        setFilterDefaulters,
        inDays,
        setInDays,
        contracts,
        setContracts,
        reimbursableExpenses,
        setReimbursableExpenses,
        totalLooseItem,
        setTotalLooseItem,
        totalBilling,
        setTotalBilling,
        negativeTaxCnab,
        setNegativeTaxCnab,
        totalTaxCnab,
        setTotalTaxCnab,
        negativeTaxPix,
        setNegativeTaxPix,
        totalTaxPix,
        setTotalTaxPix,
        netTotal,
        setNetTotal,
        itensTable,
        setItensTable,
        mainLoading,
        setMainLoading,
        selectedItem,
        setSelectedItem,
        totalQyonBank,
        setTotalQyonBank,
        taxCnab,
        setTaxCnab,
        taxPix,
        setTaxPix,
        pagePropDefault,
        setPagePropDefault,
        negativeQB,
        setNegativeQB,
        disabledButtonSearch,
        setDisabledButtonSearch,
        loadingBtnSearch,
        setLoadingBtnSearch,
        expiredTotal,
        setExpiredTotal,
        expiringTotal,
        setExpiringTotal,
      }}
    >
      {children}
    </FaturamentoContratoContext.Provider>
  );
};

export { FaturamentoContratoContextProvider, FaturamentoContratoContext };
